import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import { get } from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError, convertTwoDecimalPoint, getSchoolGrades, groupBy } from "../../../server/util";

class StudentSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      studentId: '',
      studentName: '',
      parentEmail: '',
      grade: '',
      searchStudent: [],
      emailError: null,
    }
  }

  componentWillMount = () => {
    //this.getSearchStudentDetails();
  };

  getSearchStudentDetails = () => {
    let studentId = this.state.studentId;
    let studentName = this.state.studentName;
    let parentEmail = this.state.parentEmail;
    let grade = this.state.grade;
    this.setState({ loading: true })
    get(`/manageStudents/studentData?studentId=${studentId}&studentName=${studentName}&parentEmail=${parentEmail}&grade=${grade}&access_token=`).then((response) => {
      this.setState({ loading: false });
      if (!response.ok) {
        throw Error(response.statusText);
      } else if (response.status == 204) {
        this.setState({ searchStudent: [] })
      }
      console.log('response', response);
      return response.json();
    }).then(data => {
      this.setState({ searchStudent: data });
    })
      .catch(
        (error) => {
          this.setState({ loading: false });
          console.log('Get StudentsData response', error)
        }
      )
  };
  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === 'parentEmail') {
        if (value === '') {
          // Clear the error message if the input is empty
          this.setState({ emailError: '' });
        } else if (this.validateEmail(value)) {
          // Clear the error message if the email is valid
          this.setState({ emailError: '' });
        } else {
          // Set the error message if the email is invalid
          this.setState({ emailError: 'Invalid email address' });
        }
      }
    });
  }

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
          <BeatLoader
            size={20}
            color={'#ea7066'}
            loading={this.state.loading}
          />
        </div>
        <div className="container">
          <div className="sectionTitle">
            <h2>
              <span>Student Search</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label>Student Id:</label>
              <input type="text" className="form-control" value={this.state.studentId}
                name="studentId" placeholder="Search.." onChange={(e) => {
                  this.setState({ studentId: e.target.value }, () => {
                  })
                }} autoComplete="off" />
            </div>
            <div className="col-md-3">
              <label>Student Name:</label>
              <input type="text" className="form-control" value={this.state.studentName}
                name="studentName" placeholder="Search.." onChange={(e) => {
                  this.setState({ studentName: e.target.value }, () => {
                  })
                }} autoComplete="off" />
            </div>
            <div className="col-md-3">
              <label>Parent Email:</label>
              <input type="text" className="form-control" value={this.state.parentEmail}
                name="parentEmail" placeholder="Search.." onChange={(e) => { this.handleChange(e) }}
                autoComplete="off"
              />
              {this.state.emailError && (
                <div style={{ color: 'red', marginTop: '5px' }}>
                  {this.state.emailError}
                </div>
              )}
            </div>
            {/* <div className="col-md-3">
                     <label>Grade:</label>
                      <input type="text" className="form-control" value={this.state.grade}
                        name="grade" placeholder="Search.." onChange={(e) => {
                        this.setState({ grade: e.target.value }, () => {
                            }) 
                        }} autoComplete="off" />
                   </div> */}
            <div className=" col-md-3">
              <div className="text-right" style={{ marginRight: '10px' }}>
                <button type="button" class="btn btn-danger btn-sm" onClick={() => {
                  this.getSearchStudentDetails();
                }} ><span class="glyphicon glyphicon-arrow-right"></span> Go
                </button>
                <button type="button" class="btn btn-danger btn-sm" onClick={() => {
                  this.setState({ studentId: '', studentName: '', parentEmail: '', grade: '', searchStudent: [] })
                }}><span class="glyphicon glyphicon-remove-circle"></span> Clear
                </button>
              </div>
            </div>
            <div className="col-md-12 ">
              <ReactTable
                data={this.state.searchStudent}
                columns={[
                  { Header: "School Name", width: 150, accessor: "schoolName", style: { textAlign: 'center' } },
                  { Header: "Student Name", width: 150, style: { textAlign: 'center' }, Cell: row => <span>{row.original.studentFirstName + ' ' + row.original.studentLastName}</span> },
                  { Header: 'Student Id', accessor: 'studentId', width: 100, style: { textAlign: 'center' } },
                  { Header: "Grade", width: 100, accessor: "gradeName", style: { textAlign: 'center' } },
                  { Header: 'School Year', width: 100, accessor: "schoolYear", style: { textAlign: 'center' } },
                  {
                    Header: "Status", width: 100,
                    Cell: row => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          {
                            row.original.isActive === true ?
                              <span> Active</span> :
                              row.original.isActive === false ?
                                <span> InActive</span> : null
                          }
                        </div>
                      )
                    },
                  },
                  {
                    Header: "Parent Email", width: 150,
                    Cell: row => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          {row.original.parentEmail && (
                            <div>P: {row.original.parentEmail}</div>
                          )}
                          {row.original.parentAltEmail && (
                            <div>A: {row.original.parentAltEmail}</div>
                          )}
                        </div>
                      )
                    },
                  },
                  { Header: "Parent MobileNo", width: 150, accessor: "parentMobileNo", style: { textAlign: 'center' } },
                  {
                    Header: "Meal Eligibility ", width: 200,
                    Cell: row => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          {
                            row.original.isFreeMealEligible === true ?
                              <span> Free</span> :
                              row.original.isReducePriceEligible === true ? <span>Reduced</span> :
                                <span> Regular</span>
                          }
                        </div>
                      )
                    },
                  },
                  { Header: "Student PIN", width: 150, accessor: "studentPIN", style: { textAlign: 'center' } },
                  { Header: "Teacher Name", width: 100, accessor: "teacherName", style: { textAlign: 'center' } },
                  { Header: "Category", width: 100, accessor: "category", style: { textAlign: 'center' } },
                  {
                    Header: "Acc Balance", width: 100,
                    Cell: ({ row }) => {
                      return row._original.accBalance === null ? 0 : `${row._original.currencySymbol} ${convertTwoDecimalPoint(row._original.accBalance)}`;
                    },
                  },
                  { Header: "City State Zip", width: 100, accessor: "cityStateZip", style: { textAlign: 'center' } },
                ]}
                defaultPageSize={10}
                className="-striped -highlight rtTable-Order"
                noDataText='No data found'
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default StudentSearch;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/studentSearch.jsx